/**
 *
 */
export const reduceWarehousesStock = (total, curr) => {
    //
    return total + parseFloat(curr.logical_stock)
}

/**
 *
 */
export const reduceStock = (total, curr) => {
    //
    return total + curr.wh_warehouses.reduce(reduceWarehousesStock, 0)
}

//
export default [
    {
        text: 'Códigos UPC',
        //fieldType: 'computed',
        
        value: ({ wh_product }) => {
            //
            //console.log(stocks)
            let upc_codes = wh_product.upc_codes
            //
            return upc_codes.join('\n')
        },
        whiteSpace: 'pre',
    },
    {
        text: 'Nombre',
        //fieldType: 'computed',
        value: ({ wh_product }) => {
            //
            //console.log(stocks)
            //let upc_codes = wh_product.alias_name
            //
            return wh_product.name
        },
        whiteSpace: 'pre',
    },
    {
      text: 'Alias',
      //fieldType: 'computed',
      value: ({ wh_product }) => {
          //
          //console.log(stocks)
          //let upc_codes = wh_product.alias_name
          //
          return wh_product.alias_name
      },
      whiteSpace: 'pre',
    },
    {
        text: 'Stock Critico',
        sortable: true,
        value: 'critical_stock',
    },
    {
        text: 'Stock Real',
        sortable: true,
        value: 'real_stock',
    },
    // {
    //     text: 'Códigos UPC',
    //     fieldType: 'computed',
    //     computed: ({ upc_codes }) => {
    //         //
    //         //console.log(stocks)
    //         //
    //         return upc_codes.join('\n')
    //     },
    //     whiteSpace: 'pre'
    // },
    // {
    //     text: 'Código Interno',
    //     sortable: true,
    //     value: 'internal_code',
    // },
    // {
    //     text: 'Nombre',
    //     value: 'name',
    // },
    // {
    //     text: 'Alias',
    //     value: 'alias_name',
    // },
    // {
    //     text: 'Tipo',
    //     fieldType: 'computed',
    //     computed: ({ wh_item_id, wh_pack_id, wh_packing_id, wh_promo_id }) => {
    //         //
    //         if (wh_item_id) return 'ITEM'
    //         if (wh_pack_id) return 'PACK'
    //         if (wh_packing_id) return 'PACKING'
    //         if (wh_promo_id) return 'PROMO'
    //         //
    //         return 'Desconocido'
    //     },
    // },
    // {
    //     text: 'Reenvasado',
    //     fieldType: 'computed',
    //     computed: ({ is_repackaged }) => {
    //         return is_repackaged ? 'SI' : 'NO'
    //     },
    // },
    // {
    //     text: 'Stock',
    //     fieldType: 'computed',
    //     computed: ({ stocks }) => {
    //         //
    //         //console.log(stocks)
    //         //
    //         return stocks.reduce(reduceStock, 0)
    //     },
    // },
]
